import { FormControl, FormErrorMessage, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import Input from "../inputs/Input";
import { forwardRef, useImperativeHandle } from "react";
import { Variant } from "../../types/earmold.types";

type VariantFormProps = {
  value?: Variant;
};

export type VariantFormHandler = {
  values: () => Partial<Variant>;
  valid: () => Promise<boolean>;
};

const VariantForm = forwardRef<VariantFormHandler, VariantFormProps>(
  ({ value }: VariantFormProps, ref) => {
    const methods = useForm();

    useImperativeHandle(ref, () => ({
      valid: () => {
        return methods.trigger();
      },
      values: () => {
        const values = methods.getValues()
        return {
          label: values.label,
          description: values.description,
          options: {
            data: [],
            conditions: []
          }
        }
      },
    }));
    return (
      <FormProvider {...methods}>
        <form style={{ marginTop: "32px", marginBottom: "32px" }}>
          <Flex direction="column" gap="24px">
            <FormControl isInvalid={!!methods.formState.errors.label}>
              <Input
                id="label"
                placeholder="Nom"
                defaultValue={value?.label}
                {...methods.register("label", {
                  required: "Ce champ est obligatoire",
                })}
              ></Input>
              <FormErrorMessage>
                <>{methods.formState.errors?.label?.message}</>
              </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!methods.formState.errors.description}>
              <Input
                id="description"
                placeholder="Description"
                defaultValue={value?.description ?? ''}
                {...methods.register("description")}
              ></Input>
              <FormErrorMessage>
                <>{methods.formState.errors?.description?.message}</>
              </FormErrorMessage>
            </FormControl>
          </Flex>
        </form>
      </FormProvider>
    );
  }
);

export default VariantForm;
